import { Stack, Typography, Box, CircularProgress } from "@mui/material";
import { grey } from "@mui/material/colors";
import { colorRank, rankToPercentile } from "../../utils";
import PercentileChip from "../../PercentileChip";
import { StatMetric } from "./types";

export default function StatCard({
  name,
  value,
  percentile,
  rank,
}: StatMetric) {
  const displayPercentile = percentile ?? (rank ? rankToPercentile(rank) : 0);

  return (
    <Stack alignItems="center" spacing={1}>
      <Stack alignItems="center">
        <Typography variant="body2" textAlign="center" fontWeight="bold">
          {name}
        </Typography>
        <Box
          sx={{
            width: 130,
            height: 2,
            bgcolor: "divider",
            borderRadius: 1,
          }}
        />
      </Stack>
      <Box sx={{ position: "relative", width: 80, height: 80 }}>
        <CircularProgress
          variant="determinate"
          value={100}
          size={80}
          thickness={4}
          sx={{
            color: grey[200],
            position: "absolute",
          }}
        />
        <CircularProgress
          variant="determinate"
          value={displayPercentile}
          size={80}
          thickness={4}
          sx={{
            color: grey[700],
            position: "absolute",
          }}
        />
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        >
          <PercentileChip
            value={`${value.toFixed(1)}%`}
            numeral={Math.round(displayPercentile)}
            percentile={displayPercentile}
            rank={colorRank(percentile, rank)}
          />
        </Stack>
      </Box>
    </Stack>
  );
}
